import { Log } from '../../../../sentry';

export class BootstrapError extends Error {
	constructor(message: string, sentryLog: boolean = true) {
		super(message);

		this.name = 'BootstrapError';
		this.message = message;
		if (sentryLog) {
			Log({ message: this.message, level: 'error' });
		}
	}
}
